import { jsxs, jsx } from "react/jsx-runtime";
const IconSendSvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    fill: "currentColor",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M18.834 3c0-.083 0-.167-.084-.25v-.083c0-.084-.083-.167-.166-.25-.084-.084-.167-.084-.25-.167h-.084c-.083-.083-.166-.083-.25-.083h-.25l-15.833 5c-.334.166-.5.416-.584.75 0 .333.084.666.417.833l6.5 4.083 4.084 6.5c.166.25.416.417.666.417h.084c.333 0 .583-.25.666-.583l5-15.834c.084-.166.084-.25.084-.333ZM15 4.833l-6.25 6.25L4.167 8.25 15 4.833Zm-2.25 12L9.917 12.25 16.167 6 12.75 16.833Z" })
    ]
  }
);
export {
  IconSendSvg
};
